import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { TooltipPosition, TooltipTheme } from '../tooltip.enum';

@Component({
  selector: 'tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit {

  position: TooltipPosition = TooltipPosition.DEFAULT;
  theme: TooltipTheme = TooltipTheme.LIGHT;
  //tooltip = '';
  left = 0;
  top = 0;
  visible = false;

  @Input(`tooltip`) text: string;
  @Input() contentTemplate: TemplateRef<any>;

  constructor() {
  }

  ngOnInit(): void {
  }

}